"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFissionShareUrl = void 0;
const url_1 = require("./url");
/**
 * 获取多元归因参数
 * 根据传入的参数生成包含推广信息和邀请关系的对象
 *
 * @param params - 参数对象
 * @param params.global_content - 全局内容字符串（JSON格式），包含已有的推广参数
 * @param params.promote_id - 推广ID字符串，将被转换为数字
 * @param params.uid - 用户ID，用于设置邀请人或邀请人默认值
 * @param params.isBindCommonInvite - 是否绑定邀请注册关系
 *   - true: 将用户ID作为 invite 添加到 global_content 中
 *   - false: 将用户ID作为 inviter_def 返回
 * @returns 包含 global_content 和可选的 inviter_def 的对象
 */
function getFissionShareObj(params) {
    const { global_content, promote_id, uid, isBindCommonInvite } = params;
    let _global_content = {};
    try {
        _global_content = global_content ? JSON.parse(global_content) : {};
    }
    catch (error) {
        console.error('解析 global_content 失败', error);
    }
    const _promote_id = _global_content.promote_id ? Number(_global_content.promote_id) : Number(promote_id);
    // 合并 global_content 参数和 promote_id 参数
    const globalContentObj = Object.assign(_global_content, isBindCommonInvite
        ? {
            promote_id: _promote_id,
            invite: uid
        }
        : { promote_id: _promote_id });
    const result = {
        global_content: globalContentObj
    };
    // 如果不绑定邀请注册关系，则设置邀请人默认值
    if (!isBindCommonInvite) {
        result.inviter_def = uid;
    }
    return result;
}
/**
 * 获取分享链接（前端版本，不调用短链服务和 redis）
 * 根据配置生成包含裂变分享参数的完整URL
 *
 * @param defaultUrl - 默认链接，作为基础URL
 * @param fissionShareConfigs - 裂变分享配置对象
 * @param fissionShareConfigs.defaultPromoteId - 默认推广ID，如果URL中没有则使用此值
 * @param fissionShareConfigs.isBindCommonInvite - 是否绑定邀请注册关系
 *   - true: 将用户ID添加到 global_content.invite
 *   - false: 将用户ID作为 inviter_def 参数
 * @param fissionShareConfigs.isGetPromoteIdFromUrl - 是否从当前页面URL获取 promoteId
 *   - true: 优先使用当前页面URL中的 global_content 参数
 *   - false: 使用默认链接中的 global_content 参数
 * @param uid - 用户ID，用于生成邀请关系参数
 * @returns 拼接好的分享链接字符串
 */
const getFissionShareUrl = (defaultUrl, fissionShareConfigs, uid) => {
    const { defaultPromoteId, isBindCommonInvite, isGetPromoteIdFromUrl } = fissionShareConfigs;
    // 创建默认链接的 URL 对象
    const defaultUrlObj = new url_1.UrlParser(defaultUrl);
    // 获取默认链接的查询参数
    const defaultUrlQuery = defaultUrlObj.query();
    let globalContentStr = defaultUrlQuery.global_content || '{}';
    // 获取 global_content 参数
    // 如果 isGetPromoteIdFromUrl 为 true，则取当前链接的 global_content 参数，
    // 否则取默认链接的 global_content 参数
    if (isGetPromoteIdFromUrl) {
        // 获取当前链接的查询参数
        const locationUrlQuery = new url_1.UrlParser(location.href).query();
        globalContentStr = locationUrlQuery.global_content || globalContentStr;
    }
    // 生成裂变分享参数对象
    const fissionShareObj = getFissionShareObj({
        global_content: globalContentStr,
        promote_id: defaultPromoteId,
        uid,
        isBindCommonInvite
    });
    // 合并默认URL参数和裂变分享参数
    const params = Object.assign({}, defaultUrlQuery, fissionShareObj);
    // 将参数拼接到URL上
    const shareUrl = defaultUrlObj.getUrlByParams(params);
    return shareUrl;
};
exports.getFissionShareUrl = getFissionShareUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlzc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZpc3Npb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsK0JBQWtDO0FBRWxDOzs7Ozs7Ozs7Ozs7R0FZRztBQUNILFNBQVMsa0JBQWtCLENBQUMsTUFBZ0M7SUFDeEQsTUFBTSxFQUFFLGNBQWMsRUFBRSxVQUFVLEVBQUUsR0FBRyxFQUFFLGtCQUFrQixFQUFFLEdBQUcsTUFBTSxDQUFDO0lBQ3ZFLElBQUksZUFBZSxHQUFrQixFQUFFLENBQUM7SUFFeEMsSUFBSSxDQUFDO1FBQ0QsZUFBZSxHQUFHLGNBQWMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0lBQ3ZFLENBQUM7SUFBQyxPQUFPLEtBQUssRUFBRSxDQUFDO1FBQ2IsT0FBTyxDQUFDLEtBQUssQ0FBQyxzQkFBc0IsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNqRCxDQUFDO0lBRUQsTUFBTSxXQUFXLEdBQUcsZUFBZSxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLGVBQWUsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBRXpHLHNDQUFzQztJQUN0QyxNQUFNLGdCQUFnQixHQUFrQixNQUFNLENBQUMsTUFBTSxDQUNqRCxlQUFlLEVBQ2Ysa0JBQWtCO1FBQ2QsQ0FBQyxDQUFDO1lBQ0ksVUFBVSxFQUFFLFdBQVc7WUFDdkIsTUFBTSxFQUFFLEdBQUc7U0FDZDtRQUNILENBQUMsQ0FBQyxFQUFFLFVBQVUsRUFBRSxXQUFXLEVBQUUsQ0FDcEMsQ0FBQztJQUVGLE1BQU0sTUFBTSxHQUE2QjtRQUNyQyxjQUFjLEVBQUUsZ0JBQWdCO0tBQ25DLENBQUM7SUFFRix3QkFBd0I7SUFDeEIsSUFBSSxDQUFDLGtCQUFrQixFQUFFLENBQUM7UUFDdEIsTUFBTSxDQUFDLFdBQVcsR0FBRyxHQUFHLENBQUM7SUFDN0IsQ0FBQztJQUVELE9BQU8sTUFBTSxDQUFDO0FBQ2xCLENBQUM7QUFFRDs7Ozs7Ozs7Ozs7Ozs7O0dBZUc7QUFDSSxNQUFNLGtCQUFrQixHQUFHLENBQzlCLFVBQWtCLEVBQ2xCLG1CQUF3QyxFQUN4QyxHQUFXLEVBQ0wsRUFBRTtJQUNSLE1BQU0sRUFBRSxnQkFBZ0IsRUFBRSxrQkFBa0IsRUFBRSxxQkFBcUIsRUFBRSxHQUFHLG1CQUFtQixDQUFDO0lBRTVGLGlCQUFpQjtJQUNqQixNQUFNLGFBQWEsR0FBRyxJQUFJLGVBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUNoRCxjQUFjO0lBQ2QsTUFBTSxlQUFlLEdBQUcsYUFBYSxDQUFDLEtBQUssRUFBRSxDQUFDO0lBRTlDLElBQUksZ0JBQWdCLEdBQUcsZUFBZSxDQUFDLGNBQWMsSUFBSSxJQUFJLENBQUM7SUFFOUQsdUJBQXVCO0lBQ3ZCLDZEQUE2RDtJQUM3RCw2QkFBNkI7SUFDN0IsSUFBSSxxQkFBcUIsRUFBRSxDQUFDO1FBQ3hCLGNBQWM7UUFDZCxNQUFNLGdCQUFnQixHQUFHLElBQUksZUFBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUM5RCxnQkFBZ0IsR0FBRyxnQkFBZ0IsQ0FBQyxjQUFjLElBQUksZ0JBQWdCLENBQUM7SUFDM0UsQ0FBQztJQUVELGFBQWE7SUFDYixNQUFNLGVBQWUsR0FBRyxrQkFBa0IsQ0FBQztRQUN2QyxjQUFjLEVBQUUsZ0JBQWdCO1FBQ2hDLFVBQVUsRUFBRSxnQkFBZ0I7UUFDNUIsR0FBRztRQUNILGtCQUFrQjtLQUNyQixDQUFDLENBQUM7SUFDSCxtQkFBbUI7SUFDbkIsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsZUFBZSxFQUFFLGVBQWUsQ0FBQyxDQUFDO0lBRW5FLGFBQWE7SUFDYixNQUFNLFFBQVEsR0FBRyxhQUFhLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBRXRELE9BQU8sUUFBUSxDQUFDO0FBQ3BCLENBQUMsQ0FBQztBQXJDVyxRQUFBLGtCQUFrQixzQkFxQzdCIn0=